import { z } from 'zod';

/**
 * @deprecated - add events to /types/analytics/index.ts.
 */
export const EVENT_NAME = {
  NPS_FORM_VIEWED: 'nps_form_viewed',
} as const;

/**
 * When a value is absent, it is represented by BLANK_VALUE.
 */
export const BLANK_VALUE = 'blank' as const;

export const CHARGE_ADJUSTMENT = {
  UNIVERSAL_GIFTCARD: 'universal_giftcard',
  WELLNESS_CARD: 'wellness_card',
  VALUE_CARD: 'value_card',
  BUNDLE: 'bundle',
} as const;

export const PAYMENT_METHOD = {
  PAY_IN_SALON: 'pay_in_salon',
  KLARNA: 'klarna',
  QLIRO: 'qliro',
  CARD: 'card',
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
  SWISH: 'swish',
  WALLEY: 'walley',
} as const;

export const SCREEN_NAME = {
  ABOUT: 'about',
  ACTIVATE_LOCATION: 'activate_location',
  ADD_PAYMENT_CARD_OVERLAY: 'add_paymentcard_overlay',
  APP: 'app',
  BLOG: 'blog',
  BLOG_AUTHOR: 'blog_author',
  BLOG_CATEGORY: 'blog_category',
  BLOG_POST: 'blog_post',
  BOOKING_CHOOSE_ADD_ONS: 'booking_step_choose_add_ons',
  BOOKING_CHOOSE_EMPLOYEE: 'booking_step_choose_employee',
  BOOKING_CHOOSE_EXTRA_TIME: 'booking_step_choose_extra_time',
  BOOKING_CHOOSE_SERVICE: 'booking_step_choose_service',
  BOOKING_CHOOSE_TIME: 'booking_step_choose_time',
  BOOKING_DETAILS: 'booking_details',
  BUNDLE_DETAILS: 'bundle_details',
  CANCEL_BOOKING: 'cancel_booking',
  CHECKOUT_BOOKING_CONFIRMATION: 'checkout_booking_confirmation',
  CHECKOUT_BOOKING_KLARNA_SUMMARY: 'checkout_booking_klarna_summary',
  CHECKOUT_BOOKING_KLARNA_UPDATE_PAYMENT_METHOD: 'checkout_booking_klarna_update_payment_method',
  CHECKOUT_BOOKING_QLIRO_SUMMARY: 'checkout_booking_qliro_summary',
  CHECKOUT_BOOKING_QLIRO_UPDATE_PAYMENT_METHOD: 'checkout_booking_qliro_update_payment_method',
  CHECKOUT_BOOKING_SUMMARY: 'checkout_booking_summary',
  CHECKOUT_BOOKING_SWISH_SUMMARY: 'checkout_booking_swish_summary',
  CHECKOUT_BOOKING_SWISH_UPDATE_PAYMENT_METHOD: 'checkout_booking_swish_update_payment_method',
  CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD: 'checkout_booking_update_payment_method',
  CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD_CONFIRMATION: 'checkout_booking_update_payment_method_confirmation',
  CHECKOUT_BUNDLE_CONFIRMATION: 'checkout_bundle_confirmation',
  CHECKOUT_BUNDLE_QLIRO_SUMMARY: 'checkout_bundle_qliro_summary',
  CHECKOUT_BUNDLE_SUMMARY: 'checkout_bundle_summary',
  CHECKOUT_BUNDLE_SWISH_SUMMARY: 'checkout_bundle_swish_summary',
  COMPANY_DETAILS: 'company_details',
  COOKIE_POLICY: 'cookie_policy',
  DEALS: 'deals',
  DEALS_MAP: 'deals_map',
  DEAL_DETAILS: 'deal_details',
  DELETE_PAYMENT_CARD: 'delete_payment_card',
  ETHICAL_POLICY: 'ethical_policy',
  FACTS: 'facts_and_advice',
  FAQ: 'faq',
  FAVORITES: 'favorites',
  GIFTCARD_CHECKOUT: 'gift_card_landing_page',
  GIFTCARD_USE: 'check_giftcard_wellnesscard_value',
  GOTO: 'goto',
  HOME: 'home',
  INJECTION_NOTICE: 'injection_notice',
  MY_BOOKINGS_DETAILS: 'my_bookings_booking_detail',
  MY_BOOKINGS_FINISHED: 'my_bookings_finished',
  MY_BOOKINGS_UPCOMING: 'my_bookings_upcoming',
  MY_BUNDLE_OVERVIEW: 'my_bundles_overview',
  MY_PROFILE: 'my_profile',
  NEW_DOWNLOAD_APP_BANNER: 'new_download_app_banner',
  PARTICIPANT_DETAILS: 'participant_details',
  PAYMENT_METHODS: 'payment_methods',
  PAYMENT_VALIDATION: 'payment_validation',
  PLACE_LANDING: 'place_landing',
  PLACE_VALUECARD_LANDING: 'place_value_card_landing_page',
  PORTAL: 'portal',
  PRIVACY_POLICY: 'privacy_policy',
  SEARCH_NOTICE: 'search_notice',
  SEARCH_RESULTS: 'search_results',
  SEARCH_RESULTS_MAP: 'search_results_map',
  SMT_SEARCH_RESULTS: 'smt_search_results',
  SMT_SEARCH_RESULTS_MAP: 'smt_search_results_map',
  DEALS_SEARCH_RESULTS: 'deals_search_results',
  DEALS_SEARCH_RESULTS_MAP: 'deals_search_results_map',
  SECURITY_ACKNOWLEDGEMENTS: 'security_acknowledgements',
  SECURITY_POLICY: 'security_policy',
  SUPPORT: 'support',
  SUPPORT_FORM: 'support_form',
  TERMS_BOOKING_CONSUMER: 'terms',
  TERMS_GIFTCARD_CONSUMER: 'terms_giftcard',
  TERMS_LANDING: 'terms_landing',
  TERMS_ONLINE_PAYMENT: 'terms_online_payment',
  WELLNESS_CARD_CHECKOUT: 'wellness_card_landing_page',
  TERMS: 'terms',
  NEWSLETTER: 'newsletter',
  UNSUBSCRIBE: 'unsubscribe',
  UNSUBSCRIBE_REVIEWS: 'unsubscribe_reviews',
  ADD_REVIEW: 'add_review',
  CHECK_GIFTCARD: 'check_giftcard_wellnesscard_value',
  FACTS_AND_ADVICE: 'facts_and_advice',
} as const;

export const screenNameSchema = z.enum([
  SCREEN_NAME.ABOUT,
  SCREEN_NAME.ACTIVATE_LOCATION,
  SCREEN_NAME.ADD_PAYMENT_CARD_OVERLAY,
  SCREEN_NAME.APP,
  SCREEN_NAME.ADD_REVIEW,
  SCREEN_NAME.BLOG,
  SCREEN_NAME.BLOG_AUTHOR,
  SCREEN_NAME.BLOG_CATEGORY,
  SCREEN_NAME.BLOG_POST,
  SCREEN_NAME.BOOKING_CHOOSE_ADD_ONS,
  SCREEN_NAME.BOOKING_CHOOSE_EMPLOYEE,
  SCREEN_NAME.BOOKING_CHOOSE_EXTRA_TIME,
  SCREEN_NAME.BOOKING_CHOOSE_SERVICE,
  SCREEN_NAME.BOOKING_CHOOSE_TIME,
  SCREEN_NAME.BOOKING_DETAILS,
  SCREEN_NAME.BUNDLE_DETAILS,
  SCREEN_NAME.CANCEL_BOOKING,
  SCREEN_NAME.CHECKOUT_BOOKING_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BOOKING_KLARNA_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_KLARNA_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_QLIRO_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_QLIRO_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_SWISH_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_SWISH_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BUNDLE_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BUNDLE_QLIRO_SUMMARY,
  SCREEN_NAME.CHECKOUT_BUNDLE_SUMMARY,
  SCREEN_NAME.CHECKOUT_BUNDLE_SWISH_SUMMARY,
  SCREEN_NAME.COMPANY_DETAILS,
  SCREEN_NAME.COOKIE_POLICY,
  SCREEN_NAME.DEALS,
  SCREEN_NAME.DEALS_MAP,
  SCREEN_NAME.DEALS_SEARCH_RESULTS,
  SCREEN_NAME.DEALS_SEARCH_RESULTS_MAP,
  SCREEN_NAME.DEAL_DETAILS,
  SCREEN_NAME.DELETE_PAYMENT_CARD,
  SCREEN_NAME.ETHICAL_POLICY,
  SCREEN_NAME.FACTS,
  SCREEN_NAME.FAQ,
  SCREEN_NAME.FAVORITES,
  SCREEN_NAME.GIFTCARD_CHECKOUT,
  SCREEN_NAME.GIFTCARD_USE,
  SCREEN_NAME.GOTO,
  SCREEN_NAME.HOME,
  SCREEN_NAME.INJECTION_NOTICE,
  SCREEN_NAME.MY_BOOKINGS_DETAILS,
  SCREEN_NAME.MY_BOOKINGS_FINISHED,
  SCREEN_NAME.MY_BOOKINGS_UPCOMING,
  SCREEN_NAME.MY_BUNDLE_OVERVIEW,
  SCREEN_NAME.MY_PROFILE,
  SCREEN_NAME.NEWSLETTER,
  SCREEN_NAME.NEW_DOWNLOAD_APP_BANNER,
  SCREEN_NAME.PARTICIPANT_DETAILS,
  SCREEN_NAME.PAYMENT_METHODS,
  SCREEN_NAME.PAYMENT_VALIDATION,
  SCREEN_NAME.PLACE_LANDING,
  SCREEN_NAME.PLACE_VALUECARD_LANDING,
  SCREEN_NAME.PORTAL,
  SCREEN_NAME.PRIVACY_POLICY,
  SCREEN_NAME.SEARCH_NOTICE,
  SCREEN_NAME.SEARCH_RESULTS,
  SCREEN_NAME.SEARCH_RESULTS_MAP,
  SCREEN_NAME.SMT_SEARCH_RESULTS,
  SCREEN_NAME.SMT_SEARCH_RESULTS_MAP,
  SCREEN_NAME.SECURITY_ACKNOWLEDGEMENTS,
  SCREEN_NAME.SECURITY_POLICY,
  SCREEN_NAME.SUPPORT,
  SCREEN_NAME.SUPPORT_FORM,
  SCREEN_NAME.TERMS_BOOKING_CONSUMER,
  SCREEN_NAME.TERMS_GIFTCARD_CONSUMER,
  SCREEN_NAME.TERMS_LANDING,
  SCREEN_NAME.TERMS_ONLINE_PAYMENT,
  SCREEN_NAME.UNSUBSCRIBE,
  SCREEN_NAME.UNSUBSCRIBE_REVIEWS,
  SCREEN_NAME.WELLNESS_CARD_CHECKOUT,
]);

export const CAR_INDUSTRIES = ['Biltvätt', 'Bilvård/Rekond', 'Däckbyte', 'Däckhotell', 'Däckverkstad', 'Verkstad'];
export const HAIRDRESSER_INDUSTRIES = ['Frisör', 'Hårvård'];
